const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: 'https://pyaenyeinchan.home.blog/',
  title: 'Blog.',
}

const about = {
  // all the properties are optional - can be left empty or deleted
  name: 'Pyae Nyein Chan',
  role: 'Software Engineer',
  description:
    'Passionate backend developer skilled in Java, Spring Boot, and RestAPI, proficient in Linux, and always eager to learn new technologies to drive innovation.',
  resume: 'https://drive.google.com/file/d/1lWsnVQkc0dDXH1TyvcfVsd8T-9ua2sts/view?usp=sharing',
  resume2: 'https://drive.google.com/file/d/13zrsCsnue_lCtBv5ge187_FTfDiwibAA/view?usp=sharing',
  social: {
    linkedin: 'https://www.linkedin.com/in/pyaenyeinchan',
    github: 'http://github.com/pyaenyeinchan',
  },
}

const projects = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  // {
  //   name: 'Project 1',
  //   description:
  //     'Amet asperiores et impedit aliquam consectetur? Voluptates sed a nulla ipsa officia et esse aliquam',
  //   stack: ['SASS', 'TypeScript', 'React'],
  //   sourceCode: 'https://github.com',
  //   livePreview: 'https://github.com',
  // },
  // {
  //   name: 'Project 2',
  //   description:
  //     'Amet asperiores et impedit aliquam consectetur? Voluptates sed a nulla ipsa officia et esse aliquam',
  //   stack: ['SASS', 'TypeScript', 'React'],
  //   sourceCode: 'https://github.com',
  //   livePreview: 'https://github.com',
  // },
  // {
  //   name: 'Project 3',
  //   description:
  //     'Amet asperiores et impedit aliquam consectetur? Voluptates sed a nulla ipsa officia et esse aliquam',
  //   stack: ['SASS', 'TypeScript', 'React'],
  //   sourceCode: 'https://github.com',
  //   livePreview: 'https://github.com',
  // },
]

const skills = [
  // skills can be added or removed
  // if there are no skills, Skills section won't show up
  'JavaEE',
  'SpringBoot',
  'Linux',
  'RESTAPI',
  'MySQL',
  'Figma',
  'PowerBI'

]

const contact = {
  // email is optional - if left empty Contact section won't show up
  email: 'pyaenyeinchan97@mail.com',
}

export { header, about, projects, skills, contact }